const shoppingCartTypes = {
    "ADD_TO_CART_ACTION": "ADD_TO_CART_ACTION",
    "REMOVE_CART_ACTION": "REMOVE_CART_ACTION",
    "UPDATE_QUANITY_ACTION": "UPDATE_QUANTITY_ACTION"
}

export default shoppingCartTypes